module.exports = __webpack_public_path__ + "img/clint6.5edd7c42.png";